import { render, staticRenderFns } from "./AnchorLink.vue?vue&type=template&id=70ef8924"
import script from "./AnchorLink.vue?vue&type=script&lang=js"
export * from "./AnchorLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports